import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getAverage(baseCurrency) {
        try{            
            const response = await axios.get(`Forex/average/${baseCurrency}`, {
                headers: {
                    'page_key': pageKeys.client
                }
            })            
            return response
        }catch (error){
            console.log('axios getAverage error: ' + error)
            throw error
        }
    },
}